import { DEFAULT_LANGUAGE } from '@cibli/shared';
import fr from '@cibli/shared/locales/fr.json';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
  resources: {
    fr: {
      translation: fr,
    },
  },
  lng: DEFAULT_LANGUAGE,
  // Resources are registered under the base code ('fr' …), so the fallback must
  // use the base code too — 'fr-FR' resolves no bundle and every missing key
  // would leak as a raw key instead of falling back to French.
  fallbackLng: DEFAULT_LANGUAGE.split('-')[0],
  // Configuration to handle errors without automatic fallback
  returnNull: false,
  returnEmptyString: false,
  // Disable returning the key if the translation is missing
  keySeparator: '.',
  nsSeparator: ':',
  interpolation: {
    escapeValue: false,
  },
});
